var _path, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssistanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3016 0.555162C11.3313 0.32224 11.6687 0.322242 11.6984 0.555163L12.3115 5.3614C12.5998 7.62105 14.379 9.40021 16.6386 9.68848L21.4448 10.3016C21.6778 10.3313 21.6778 10.6687 21.4448 10.6984L16.6386 11.3115C14.379 11.5998 12.5998 13.379 12.3115 15.6386L11.6984 20.4448C11.6687 20.6778 11.3313 20.6778 11.3016 20.4448L10.6885 15.6386C10.4002 13.379 8.62105 11.5998 6.36139 11.3115L1.55516 10.6984C1.32224 10.6687 1.32224 10.3313 1.55516 10.3016L6.3614 9.68848C8.62105 9.40021 10.4002 7.62105 10.6885 5.36139L11.3016 0.555162Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 2.5,
    x2: 24,
    y2: 2.5,
    stroke: "white",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 5,
    x2: 21.5,
    y2: 3.27835e-8,
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistanceIcon);
export default __webpack_public_path__ + "static/media/assistance-icon.93bf06ceab1d1fc8e728021c0d0db9b5.svg";
export { ForwardRef as ReactComponent };